import React, { useState } from 'react';
import { useLang } from '../i18n/useLang';

const articleConfig = [
  { featured: true, slug: 'diagnostic-ai-west-africa', topic: 'AI for Health', topicCls: 'bg-nf-teal/10 text-nf-teal', bgEmoji: '🏥', avCls: 'bg-nf-teal/20 text-nf-teal', author: 'KN', authorName: 'Kwame Nkrumah-Asante', date: 'Dec 2024' },
  { slug: 'multiagent-logistics-east-africa', topic: 'Agentic Systems', topicCls: 'bg-nf-cyan/10 text-nf-cyan', bgEmoji: '🤖', avCls: 'bg-nf-cyan/20 text-nf-cyan', author: 'MS', authorName: 'Mele Sithole', date: 'Nov 2024' },
  { slug: 'medical-dataset-wolof-hausa', topic: 'Dataset Creation', topicCls: 'bg-nf-amber/10 text-nf-amber', bgEmoji: '🗄️', avCls: 'bg-nf-amber/20 text-nf-amber', author: 'DN', authorName: 'Dina Ndiaye', date: 'Nov 2024' },
  { slug: '48h-prototype-framework', topic: 'Fast Prototyping', topicCls: 'bg-nf-rose/10 text-nf-rose', bgEmoji: '⚡', avCls: 'bg-nf-rose/20 text-nf-rose', author: 'BI', authorName: 'Babajide Ige', date: 'Oct 2024' },
  { slug: 'llm-finetuning-african-languages', topic: 'ML', topicCls: 'bg-nf-p3/10 text-nf-p3', bgEmoji: '🧠', avCls: 'bg-nf-p3/20 text-nf-p3', author: 'ZO', authorName: 'Zara Okonkwo', date: 'Oct 2024' },
  { slug: 'genai-opportunity-map-2025', topic: 'Market Research', topicCls: 'bg-nf-green/10 text-nf-green', bgEmoji: '📊', avCls: 'bg-nf-green/20 text-nf-green', author: 'AT', authorName: 'Amara Touré', date: 'Sep 2024' },
  { slug: 'smart-cameras-traffic-lights', topic: 'Smart Cities', topicCls: 'bg-orange-500/10 text-orange-400', bgEmoji: '🚦', avCls: 'bg-orange-500/20 text-orange-400', author: 'WCT', authorName: 'Willy Carlos Tchuitcheu', date: 'Sep 2020' },
  { slug: 'rf-drive-test-app', topic: 'Telecom', topicCls: 'bg-cyan-500/10 text-cyan-400', bgEmoji: '📡', avCls: 'bg-cyan-500/20 text-cyan-400', author: 'DSS', authorName: 'Darix Samani Siewe', date: 'Dec 2023' },
  { slug: 'hospital-los-domain-adaptation', topic: 'AI for Health', topicCls: 'bg-nf-teal/10 text-nf-teal', bgEmoji: '🏨', avCls: 'bg-nf-teal/20 text-nf-teal', author: 'LNWM', authorName: 'Lyse Naomi Wamba Momo', date: 'Jul 2024' },
];

const sidebarAuthorConfig = [
  { initials: 'KN', avCls: 'bg-nf-teal/20 text-nf-teal', name: 'Kwame Nkrumah-Asante' },
  { initials: 'ZO', avCls: 'bg-nf-p3/20 text-nf-p3', name: 'Zara Okonkwo' },
  { initials: 'DN', avCls: 'bg-nf-green/20 text-nf-green', name: 'Dina Ndiaye' },
  { initials: 'AT', avCls: 'bg-nf-amber/20 text-nf-amber', name: 'Amara Touré' },
];

export default function Blog() {
  const { t, lang } = useLang();
  const articles = articleConfig.map((cfg, i) => ({ ...cfg, ...t('blog.articles')[i] }));
  const sidebarAuthors = sidebarAuthorConfig.map((cfg, i) => ({ ...cfg, role: t('blog.authorRoles')[i] }));
  const filterKeys = t('blog.filterKeys');
  const filterLabels = t('blog.filterLabels');
  const topicLabel = (key) => { const i = filterKeys.indexOf(key); return i >= 0 ? filterLabels[i] : key; };
  const [activeFilter, setActiveFilter] = useState('All');

  const filtered = activeFilter === 'All'
    ? articles
    : articles.filter(a => a.topic === activeFilter);

  return (
    <div>
      {/* Hero */}
      <div className="pt-[72px] sm:pt-[80px] pb-8 lg:pb-12 px-4 sm:px-8 lg:px-20 text-center relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none"
          style={{ background: 'radial-gradient(ellipse 50% 60% at 50% 30%, rgba(109,40,217,.12) 0%, transparent 65%)' }} />
        <div className="relative max-w-[1100px] mx-auto">
          <span className="sec-label">{t('blog.secLabel')}</span>
          <h1 className="font-heading font-black leading-[1.05] tracking-[-0.03em] max-w-[700px] mx-auto mt-4 mb-4"
            style={{ fontSize: 'clamp(26px, 3.8vw, 52px)' }}>
            {t('blog.h1')[0]}<span className="text-nf-p3">{t('blog.h1')[1]}</span>
          </h1>
          <p className="text-[15px] text-nf-t2 max-w-[540px] mx-auto mb-6">{t('blog.heroBody')}</p>
          <div className="flex flex-wrap justify-center gap-2">
            {filterKeys.map((key, i) => (
              <button
                key={key}
                className={`px-4 py-2 rounded-full text-sm border transition-all cursor-pointer ${activeFilter === key ? 'bg-nf-p/20 border-[rgba(109,40,217,0.4)] text-nf-acc' : 'bg-transparent border-white/[0.08] text-nf-t2 hover:border-white/[0.2] hover:text-nf-text'}`}
                onClick={() => setActiveFilter(key)}>{filterLabels[i]}</button>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <section id="blog-articles" className="px-4 sm:px-8 lg:px-20 pb-16 lg:pb-24">
        <div className="max-w-[1100px] mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 items-start">
            {/* Articles */}
            <div className="flex-1">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
                {filtered.map((a, i) => (
                  <div key={i} className={`group bg-nf-bg3 border border-white/[0.06] rounded-2xl overflow-hidden transition-all hover:border-[rgba(109,40,217,0.22)] hover:-translate-y-0.5 ${a.featured ? 'sm:col-span-2' : ''}`}>
                    <div className={`flex items-center justify-center text-[40px] sm:text-[48px] bg-nf-bg2 ${a.featured ? 'h-[100px] sm:h-[160px]' : 'h-[80px] sm:h-[90px]'}`}>
                      {a.bgEmoji}
                    </div>
                    <div className="p-4 sm:p-6">
                      <div className="flex items-center gap-3 mb-3">
                        <span className={`text-[11px] px-2.5 py-[3px] rounded-full font-semibold ${a.topicCls}`}>{topicLabel(a.topic)}</span>
                      </div>
                      <h3 className="font-heading text-[14px] sm:text-[15px] font-extrabold mb-2 leading-snug">{a.title}</h3>
                      <p className="text-sm text-nf-t2 leading-[1.65] mb-4">{a.body}</p>
                      <div className="flex flex-wrap items-center justify-between gap-2">
                        <div className="flex items-center gap-2 min-w-0">
                          <div className={`w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold shrink-0 ${a.avCls}`}>{a.author}</div>
                          <div className="min-w-0">
                            <div className="text-[12px] font-semibold truncate max-w-[160px]">{a.authorName}</div>
                            <div className="flex items-center gap-2">
                              <div className="text-[10px] text-nf-t3">{a.date}</div>
                              {a.readTime && <div className="text-[10px] text-nf-t3">⏱ {a.readTime}</div>}
                            </div>
                          </div>
                        </div>
                        <a
                          href={`/articles/${a.slug}-${lang}.html`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-[12px] text-nf-p3 hover:text-nf-acc transition-colors inline-flex items-center gap-1 shrink-0">
                          {a.readMore} →
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Sidebar */}
            <div className="w-full lg:w-[280px] shrink-0 lg:sticky top-[90px] flex flex-col gap-5">
              <div className="bg-nf-bg3 border border-white/[0.06] rounded-2xl p-5">
                <h4 className="font-heading text-[14px] font-extrabold mb-4">{t('blog.authorsTitle')}</h4>
                <div className="flex flex-col gap-3.5">
                  {sidebarAuthors.map(a => (
                    <div key={a.initials} className="flex items-center gap-3">
                      <div className={`w-9 h-9 rounded-full flex items-center justify-center text-[12px] font-bold shrink-0 ${a.avCls}`}>{a.initials}</div>
                      <div>
                        <div className="text-[13px] font-semibold">{a.name}</div>
                        <div className="text-[11px] text-nf-t3">{a.role}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="bg-nf-bg3 border border-white/[0.06] rounded-2xl p-5">
                <h4 className="font-heading text-[14px] font-extrabold mb-4">{t('blog.topicsTitle')}</h4>
                <div className="flex flex-wrap gap-2">
                  {t('blog.tags').map(tag => <span key={tag} className="chip cursor-pointer hover:border-nf-p/40">{tag}</span>)}
                </div>
              </div>
              <div className="bg-[rgba(109,40,217,0.08)] border border-[rgba(109,40,217,0.22)] rounded-2xl p-5">
                <h4 className="font-heading text-[14px] font-extrabold mb-2">{t('blog.newsletterTitle')}</h4>
                <p className="text-[12px] text-nf-t2 mb-4">{t('blog.newsletterBody')}</p>
                <input
                  type="email"
                  placeholder={t('blog.newsletterPlaceholder')}
                  className="w-full bg-nf-bg border border-white/[0.08] rounded-lg px-3 py-2 text-sm text-nf-text placeholder:text-nf-t3 mb-2.5 outline-none focus:border-nf-p/50"
                />
                <button className="btn-cta w-full text-sm py-2">{t('blog.newsletterBtn')}</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
